export const baseUrl = '/api/taxonomy';
